import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    const semantic = getDynamicSemanticToken(theme);
    const { typography, shadow, zIndex } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        zIndex: zIndex.Popover,
        width: 'auto',
        maxWidth: '400px',
        padding: 12,
        fontSize: typography.fontSize.body,
        fontFamily: typography.fontFamily,
        border: semantic.border.subtle.neutral,
        borderRadius: 8,
        arrow: {
            width: '1em',
            height: '0.71em',
            color: semantic.fill.default,
            border: semantic.border.subtle.neutral,
        },
        title: {
            color: semantic.text.stronger.neutral,
            fontWeight: typography.fontWeight.bodyBold,
            lineHeight: typography.lineHeight.bodyBold,
            paddingRight: '30px',
            marginBottom: '4px',
        },
        closeIcon: {
            position: 'absolute',
            right: '-6px',
            top: '-6px',
        },
        content: {
            color: semantic.text.stronger.neutral,
            fontWeight: typography.fontWeight.body,
            lineHeight: typography.lineHeight.body,
            paddingRight: '30px',
            a: {
                color: semantic.text.primary,
            },
        },
        footer: {
            marginTop: 16,
            paddingRight: 36,
            ok: {
                marginLeft: 8,
            },
        },
        outline: {
            default: 'none',
            focus: `2px solid ${semantic.border.primary}`,
            offset: 2,
        },
        background: semantic.fill.default,
        boxShadow: shadow.lg,
    };
}
